module.exports = __webpack_public_path__ + "static/media/Pepsi.13b1a5d1.svg";